import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { RoarAssignmentFormService } from '../../../../shared/services/roarAssignmentForm.service';

@Component({
  selector: 'review-roar-activity-review',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-roar-activity-review.component.html',
  styleUrl: './review-roar-activity-review.component.css'
})
export class ReviewRoarActivityReviewComponent implements OnInit {
  
  @Input() roarId: string | null = null;
  
  yesNo = EYesNo;
  roarAssignmentForm: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "ROAR Activity Review",
      children: [
        {
          type: 'string',
          questionText: "Review Notes:",
          answer: "review_notes"
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "review_user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "review_user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "review_user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "review_user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "review_user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "review_date_time_signed"
        }
      ]
    },
  ];

  constructor(
    private roarAssignedFormService: RoarAssignmentFormService
  ) { }

  ngOnInit(): void {
    this.loadRoarAssignmentForm();
  }

  loadRoarAssignmentForm(): void {
    if (this.roarId) {
      this.loading = true;
      this.roarAssignedFormService.getRoarAssignmentFormByRoarId(this.roarId).subscribe({
        next: (response) => {
          if (Object.keys(response).length === 0) {
            this.roarAssignmentForm = null;
            this.loading = false;
            return
          } else {
            this.roarAssignmentForm = response;
            this.loading = false;
            return
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    }
  }
}
